export default __webpack_public_path__ + "static/media/fb_logo.bed5a609.svg";